import "./navbar.scss";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import { DarkModeContext } from "../../context/darkModeContext";
import { AuthContext } from "../../context/AuthContext";
import { useContext } from "react";

const Navbar = ({ toggleSidebar, sidebarVisible }) => {
  const { dispatch, darkMode } = useContext(DarkModeContext);
  const { currentUser } = useContext(AuthContext);

  return (
    <div className="navbar">
      <div className="navbar__wrapper">

        {/* ── Left: menu toggle ── */}
        <div className="navbar__left">
          <button
            className={`navbar__toggle ${sidebarVisible ? "navbar__toggle--active" : ""}`}
            onClick={toggleSidebar}
            aria-label="Toggle sidebar"
          >
            <MenuIcon />
          </button>
        </div>

        {/* ── Right: actions ── */}
        <div className="navbar__right">

          {/* Notificaciones */}
          <div className="navbar__item">
            <NotificationsNoneOutlinedIcon className="navbar__icon" />
            <span className="navbar__badge">3</span>
          </div>

          {/* Mensajes */}
          <div className="navbar__item">
            <ChatBubbleOutlineOutlinedIcon className="navbar__icon" />
            <span className="navbar__badge">1</span>
          </div>

          {/* Dark mode toggle */}
          <div className="navbar__item" onClick={() => dispatch({ type: "TOGGLE" })}>
            {darkMode
              ? <LightModeOutlinedIcon className="navbar__icon" />
              : <DarkModeOutlinedIcon className="navbar__icon" />
            }
          </div>

          {/* Avatar / user */}
          <div className="navbar__user">
            <div className="navbar__avatar">
              {currentUser?.nombre
                ? currentUser.nombre.charAt(0).toUpperCase()
                : "U"}
            </div>
            {currentUser?.nombre && (
              <span className="navbar__username">{currentUser.nombre}</span>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Navbar;